export const CALCULATION_PRICE_SERVICE = {
  cart: 'CART',
  plus: 'PLUS-CHECKOUT',
  checkout: 'ECOMM-CHECKOUT',
} as const;

export type CalculationPriceService = (typeof CALCULATION_PRICE_SERVICE)[keyof typeof CALCULATION_PRICE_SERVICE];

export const GAMIFICATION_THRESHOLD_TYPES = Object.freeze({
  NUMBER_OF_ITEMS: 'NUMBER_OF_ITEMS',
  PRODUCT_GRAMS: 'PRODUCT_GRAMS',
  SPENDING_AMOUNT: 'SPENDING_AMOUNT',
} as const);
